<template>
  <section :class="[this.isDesktop ? 'mains-btn-content' : '']">
    <div
      :class="['mains', bindLayoutClass]"
      :style="payBgColor"
      v-if="isMobile"
    >
      <div :class="['lt']">
        <div class="price-con">
          <MyPriceTaxRate
            :injectColor="priceColor.color"
            :isBeat="true"
            :price="hackFinalPrice"
          />
          <!-- 划线价格 -->
          <div
            class="scribing-price"
            :style="bindScribingStyle"
            v-show="isRenderScribingPrice"
          >
            <div class="prefix">
              <div class="prefix-text" :style="priceColor">
                {{ originalPriceText }}:&nbsp;&nbsp;
              </div>
            </div>
            <GeneralPrice
              :injectColor="priceColor.color"
              :className="'scribing'"
              :price="originalPrice"
              :isRenderKB="true"
            />
          </div>
        </div>
      </div>
      <div class="rt">
        <div
          :class="submitOrderBtnClass"
          :style="submitBgColor"
          @click="submitOrderRequest"
        >
          {{ submitText }}
        </div>
      </div>
    </div>

    <!--
       -- PC版的底部提交按钮
       -- 新版的PC全部兼容之后、底部的按钮样式统一成一个、不会以game名称兼容
    -->
    <div
      v-else
      :class="submitOrderBtnClass"
      :style="submitBgColor"
      @click="submitOrderRequest"
    >
      <span :style="{ color: pcTextColor }" class="prefix">{{
        submitText
      }}</span>
    </div>
    <Wallet
      ref="walletRef"
      :gotoOrder="gotoOrder"
      :readyToSubmit="readyToSubmit"
      :couponPayPrice="hackFinalPrice"
      :detailChannelList="paymentChannel"
      @setEncodedPw="setEncodedPw"
      @onCheckWalletReadyToPay="onCheckWalletReadyToPay"
      @gotoPay="gotoPay"
      v-if="!isGenshinEn"
    />
    <!-- 未登录优惠券弹窗 ru-genshin -->
    <DiscountPopup
      v-model="isGenshinLayer"
      :isKwalletSelected="isKwalletSelected"
      :channelPrice="finalPrice"
      @gotoPay="genshinPay"
    />
  </section>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import isEqual from 'lodash/isEqual'
  import GeneralPrice from '@/components/GeneralPrice'
  import MyPriceTaxRate from '@page_detail/components/MyPriceTaxRate'
  import Wallet from '@page_detail/wallet'
  import bus from '@/utils/bus'
  import DiscountPopup from '@page_detail/components/DiscountPopup'
  import calculatePrice from '@/mixins/detail/calculatePrice'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { priceFormat } from '@/utils/priceFormat'
  import { TopLupe_WalletName } from '@/pages/Detail/config'
  import { placeOrder } from '@/api/games'
  import { injectionCheckUid } from '@page_detail/utils/validators'
  import {
    beginCheckout,
    pageOrder,
    pageOrderFail,
  } from '@page_detail/firebase'
  import { createUidParames } from '@page_detail/utils/common'
  import { checkCreditCard } from '@page_detail/helper'
  import { regionCodeMap } from '@/consts'
  import { storage } from '@/utils/storage'
  import { beginCheckoutTT } from '@/utils/fbTtTrack'
  import { setRouteBase } from '@/config/routePrefix'
  import { trackWalletPaidResult } from '@/pages/Wallet/firebase'
  import { tryToNative, changeTitleBarMode } from '@/utils/native'
  import { jumpToPage } from '@/utils/utils'
  import { emailReg } from '@/utils/regExp'

  const SHIPMEN_TTYPE = [1, 3]
  /** 提交按钮点击间隔（ms），短于此间隔的重复点击直接忽略，防止多笔订单 */
  export const SUBMIT_CLICK_INTERVAL = 2000

  export default {
    name: 'new-main-Temp',
    mixins: [calculatePrice, styleConfiguration],
    components: {
      Wallet,
      GeneralPrice,
      MyPriceTaxRate,
      DiscountPopup,
    },
    data() {
      return {
        isGenshinPay: false, // 是否未登录原神弹层支付
        isGenshinLayer: false, // 是否展示原神优惠价格弹窗
        encodedPw: '', // 加密后的密码、
        gotoOrder: false,
        otherchannels: false, // hack CODE\API-code 模式 未登录下单、登录成功之后直接请求订单接口
        isKwalletSelected: false, // 选中的支付通道是否为 钱包
        priceFormat: priceFormat,
        curautopayname: '', // 未登录的下、自动登录成功下单的状态
        setautopayname: '', // 未登录的下、自动登录成功下单切换的状态
        setautoskuname: '', // 切换SKU的状态、以上两个字段使用
        lastSubmitClickTime: 0, // 上次点击提交的时间戳，用于点击间隔限制
      }
    },
    mounted() {
      this.initData()
    },
    computed: {
      ...mapState([
        'currency',
        'region',
        'gameName',
        'isDesktop',
        'isMobile',
        'isTurbo',
        'source',
        'userInfo',
        'customGames', // warn pns、3D 【后期抽离到 -> vuex\detail 统一管理】
        'isIAP',
      ]),
      ...mapState('detail', [
        'calfinalPrice',
        'paymentChannel',
        'selectSkuItem',
        'selectChannelItem',
        'selectServerItem',
        'couponData',
        'userId',
        'uidValidator',
        'submitClickStatus',
        'submitButtonState',
        'loadingBySkuChannels',
        'exeOrderMethod',
        'createCouponrState',
        'selectOuterSkuItem',
        'nickName',
        'accountId',
        'ikCpServerId',
        'userRoles',
        'checkffuid',
        'isRenderCheckffuid',
        'serverUserId',
        'serverId',
        'isShowDiscount',
        'notificationEmail',
      ]),
      ...mapGetters([
        'displayTurbo',
        'selectedUidKey',
        'hasCouponGames',
        'isLogin',
        'isRuPubgm',
        'isAllExternalGames',
        'isNotCheckGames',
        'isKungfuLegend',
        'isInfinityKingdom',
        'isGenshinEn',
        'isStateOfSurvival',
        'isParallelRequestsGame',
        'isGenshin',
        'isNotExternalInputServerGames',
        'isNotExternalServerCheckGames',
        'isOnmyojiArena',
        'isCpMd',
        'isZoneIdInputGame',
      ]),
      bindScribingStyle() {
        return {
          '--delColor': this.priceColor.color || '#ffffff99',
        }
      },

      // 选中的外置SKU
      selectExternalSku() {
        if (isEmpty(this.selectOuterSkuItem)) return {}
        return JSON.parse(this.selectOuterSkuItem)
      },

      // 列表型的SKU、进行搜索交互的时候需要隐藏价格信息、只有点击才能生效
      isRenderTemp() {
        if (this.skuModuleType === 2) {
          return !isEmpty(this.selectSkuItem)
        }
        return true
      },

      pcBgColor() {
        return this.submitBgColor
      },
      pcTextColor() {
        return '#fff'
      },

      submitOrderBtnClass() {
        const defaultClass = this.isMobile ? 'st-button' : 'mains-desktop'

        let isNotclickable = ''

        // 针对测试环境、SKU未配置支付通道、默认不可以点击
        if (isEmpty(this.selectChannelItem)) {
          isNotclickable = 'not-clickable'
        } else if (this.isNotCheckGames) {
          // 外部CP：只有一个userID的场景
          isNotclickable = this.hackNotCheckGames
        } else if (this.isNotExternalInputServerGames) {
          // 外部CP: 同时需要输入serverId && userid 但是不校验的场景
          const res = !(this.userId && this.serverId)
          isNotclickable = res ? 'not-clickable' : ''
          // 外部CP: 一个UID一个serverList、「不需要校验」
        } else if (this.isNotExternalServerCheckGames) {
          isNotclickable = this.userId === '' ? 'not-clickable' : ''
        } else if (this.isParallelRequestsGame) {
          isNotclickable = this.serverUserId.value === '' ? 'not-clickable' : ''
        } else {
          // 模板化code类型CP的场景
          const isEdited = this.awardType === 2 && !this.readyToSubmit
          isNotclickable = isEdited ? 'not-clickable' : ''
        }

        return [defaultClass, isNotclickable]
      },

      hackNotCheckGames() {
        let clas = ''

        const isUidEmpty = !!(this.checkffuid == '' && this.userId === '')
        const isContrast = !!(this.checkffuid !== this.userId)

        // 只有第一次进入的会校验两个输入框的val是否一致。
        if (this.isRenderCheckffuid) {
          clas = isUidEmpty || isContrast ? 'not-clickable' : ''
        } else {
          clas = this.userId === '' ? 'not-clickable' : ''
        }
        return clas
      },
      submitText() {
        const specialGames = ['soul-land3d', 'genshin-en', 'shining-nikki']
        let subText = ''

        if (specialGames.includes(this.gameName)) {
          subText = this.$t(`${this.gameName}.submit_btn_text`)
        } else {
          subText = this.$t('order.continue_to_pay')
        }

        return subText
      },
      originalPriceText() {
        return this.$t('common.originalPriceText')
      },

      // warn uidEntering 输入过程中、不能点击提交
      readyToSubmit() {
        const isNormalPrice = this.finalPrice >= 0

        if (SHIPMEN_TTYPE.includes(this.awardType)) {
          return !!isNormalPrice
        }
        if (this.isZoneIdInputGame) {
          return !!(
            this.userId &&
            !this.uidValidator.isInInput &&
            isNormalPrice &&
            this.selectServerItem?.cpServerId
          )
        }

        // 列表型、需要校验SKU是否存在、才能确定按钮是否可以点击
        if (this.skuModuleType === 2) {
          if (this.isParallelRequestsGame) {
            return !!(
              this.serverUserId?.value &&
              !this.uidValidator.isInInput &&
              isNormalPrice &&
              !isEmpty(this.selectSkuItem)
            )
          }
          return !!(
            this.userId &&
            !this.uidValidator.isInInput &&
            isNormalPrice &&
            !isEmpty(this.selectSkuItem)
          )
        }
        if (this.uidModuleType === 6) {
          return !!(
            this.notificationEmail &&
            emailReg.test(this.notificationEmail) &&
            !this.uidValidator.isInInput &&
            isNormalPrice &&
            !isEmpty(this.selectSkuItem)
          )
        }
        return !!(this.userId && !this.uidValidator.isInInput && isNormalPrice)
      },

      // 最终的UID
      cacheUserId() {
        const suid = storage.get(this.selectedUidKey)
        if (this.userId) return this.userId
        if (suid) return suid
        return ''
      },

      bindLayoutClass() {
        let _class = []
        if (this.isDesktop) {
          _class.push('desktop')
        }
        if (this.isTurbo) {
          _class.push('turbo')
        }
        // 不显示优惠信息栏 那么直接返回阴影
        if (!this.isShowDiscount) {
          _class.push('shadow')
        }

        return _class
      },

      // CODE || API-CODE 模式登录之后、自动下单
      hackWatchCoupon() {
        return {
          userInfo: this.userInfo,
          ouponState: this.createCouponrState,
        }
      },

      // tips: 外部提交按钮是否可以点击
      // 主要是PC
      wahthInputStatus() {
        return {
          userId: this.userId,
          awardType: this.awardType,
          selectServerItem: this.selectServerItem,
          uidValidator: this.uidValidator,
        }
      },
    },

    watch: {
      wahthInputStatus: {
        handler(newVal) {
          const {
            userId = '',
            awardType = 1,
            selectServerItem = {},
            uidValidator,
          } = newVal

          // 输入中不能点击
          const { isInInput = false } = uidValidator
          // 校验UID模板、API模式
          if (awardType === 2) {
            const IsUid = userId.trim() !== ''

            if (this.isZoneIdInputGame) {
              const { cpServerId = '' } = selectServerItem
              const status = !!(IsUid && cpServerId)
              this['detail/setSubmitButtonState'](status)
            } else {
              const status = IsUid && !isInInput
              this['detail/setSubmitButtonState'](status)
            }
          }
        },
        deep: true,
        immediate: true,
      },
      // 外部组件直接调起下单的方法
      exeOrderMethod(newVal) {
        if (newVal == -1) return
        this.submitOrderRequest()
      },
      // 未登录初始化数据
      isLogin: {
        handler(newVal) {
          if (newVal) return

          if (SHIPMEN_TTYPE.includes(this.awardType)) {
            this['detail/setSubmitButtonState'](true)
          }

          this.initData()
        },
        deep: true,
        immediate: true,
      },
      // warn 其他支付通道、登录完成直接下单
      // warn 依赖 优惠券接口是否计算完毕
      hackWatchCoupon: {
        handler(newVal) {
          const { userInfo, ouponState = {} } = newVal

          const _isCoupon = ouponState.isCoupon
          const _isCompute = ouponState.isCompute

          // warn 必须是点击下单、自动登录才能触发
          if (isEmpty(userInfo)) return

          // 选中是其他的支付通道、需要登录的走自动下单逻辑
          if (!this.otherchannels) return
          // 拦截切换不同的支付通道、不自动执行、因为每次切换sku\支付通道的时候 都会刷新优惠券的接口
          if (this.curautopayname !== this.setautopayname) return
          // 反复切换 Kwallet 只执行一次；未登录→已登录时优惠券状态可能多次变为 (success,success)，只执行一次下单
          if (this.hackmun > 0) return

          if (_isCoupon === 'fail') {
            this.checkingOrderStatus()
          } else if (_isCoupon === 'success' && _isCompute !== 'pending') {
            this.hackmun++
            this.checkingOrderStatus()
          }
        },
        deep: true,
        immediate: true,
      },

      // tips： 钱包逻辑、依赖于用户登录\登出的状态
      // 后期需要优化逻辑 把当前的逻辑和hackWatchCoupon融合
      // 之所以不放在 【hackWatchCoupon】、因为点击支付通道切换、优惠券切换会触发【createCouponrState】 反复请求接口
      userInfo: {
        handler(newVal) {
          // 默认的钱包逻辑、
          if (isEmpty(newVal)) return
          this.callwalletPopup(newVal)
        },
        deep: true,
        immediate: true,
      },

      selectChannelItem: {
        handler(newVal) {
          if (isEmpty(newVal)) return
          this.isKwalletSelected = newVal.payMethodName === TopLupe_WalletName
          this.setautopayname = newVal.payMethodName

          // warn： 为了解决code模式、钱包等支付通道 未登录支付自动支付的问题
          // warn: 选择钱包的时候 只能执行一次自动支付的逻辑
          // warn: 当前是钱包 && 登录状态 && 点击跳转的时候执行
          if (this.isKwalletSelected && this.isLogin && this.otherchannels) {
            this.hackmun++
          }
        },
        deep: true,
        immediate: true,
      },
      // 点击提交订单、同时更新获取【应急云控】的状态、提交订单
      submitClickStatus: {
        handler(newVal) {
          if (isEmpty(newVal)) return
          // 1、校验应急弹层的逻辑
          if (newVal.type === 'success') {
            this.checkingOrderStatus()
          } else {
            this['detail/setSubmitButtonState'](false)
          }
        },
        deep: true,
      },
    },
    beforeDestroy() {
      bus.$off('show-account-risk')
    },
    methods: {
      ...mapMutations([
        'detail/setSubmitCloudControl',
        'detail/setIsPierceLogoLayer',
        'detail/setAPPnoReloadPage',
        'detail/setSubmitButtonState',
        'detail/setCreateCouponrState',
        'detail/setUidValidator',
      ]),

      initData() {
        this.otherchannels = false
        this.hackmun = 0
        this.isKwalletSelected = false
        this['detail/setIsPierceLogoLayer'](-1)
        this['detail/setCreateCouponrState']({
          isCoupon: 'pending',
          isCompute: 'pending',
        })
      },

      // 选中钱包支付通道、调起钱包的弹层
      callwalletPopup(newVal) {
        const data = {
          status: 1,
          userInfo: newVal,
        }
        this.$nextTick(() => {
          this.$refs.walletRef && this.$refs.walletRef.login(data)
        })
      },

      gotoPay() {
        this.checkingOrderStatus()
      },
      setEncodedPw(data) {
        this.encodedPw = data
      },
      onCheckWalletReadyToPay() {
        this.checkWallet()
      },
      getReturnUrl() {
        if (isEmpty(this.selectChannelItem)) return ''
        const kicoinId = this.isLogin ? this.userInfo.kicoinId : ''

        let { payMethodName } = this.selectChannelItem
        let { serverid } = this.$route.query
        let fix = setRouteBase() === '/' ? '' : setRouteBase()
        let jumpPage = 'pay-result'
        let worigin = window.location.origin
        let mode = this.displayTurbo ? 'gt' : 'default'
        let _serverid = serverid ? '&serverid=' + serverid : ''
        let _payMethodName = this.isKwalletSelected
          ? '&payMethodName=' + payMethodName
          : ''

        const url = `${worigin}${fix}/${jumpPage}?kicoinId=${kicoinId}&game=${this.gameName}&source=${this.source}&mode=${mode}&fromPage=detail${_serverid}${_payMethodName}`
        return url
      },

      canPayByWeakNetwork() {
        // 弱网情况是否可以下单
        const skuId = this.selectSkuItem?.skuId
        // 如果当前选中的商品在加载中，则不允许下单
        const loadingBySkuChannels = this.loadingBySkuChannels || {}
        return (
          loadingBySkuChannels?.[skuId] !== undefined &&
          !loadingBySkuChannels?.[skuId]
        )
      },

      // 下单前 检查订单的状态
      async checkingOrderStatus() {
        // 2、校验信用卡
        const isCreditCard = this.validateCreditCard()
        window.console.log('6) 校验信用卡是否需要登录')
        if (!isCreditCard) {
          this['detail/setSubmitButtonState'](false)
          return
        }
        // 3、金额必须正常显示「优惠金额不能大于支付金额」
        let isNormal = this.checkCanPay()
        window.console.log('7) 校验金额是否正确')
        if (!isNormal) {
          this['detail/setSubmitButtonState'](false)
          return
        }
        // 4、下单前校验UID
        let ischeckUid = await this.checkUID()
        window.console.log('8) 校验输入的UID是否正确')
        if (!ischeckUid) {
          this['detail/setSubmitButtonState'](false)
          return
        }

        // 5、 下单前校验钱包
        const isCheckWallet = this.checkWallet()
        window.console.log('9) 校验钱包')
        if (!isCheckWallet) {
          this['detail/setSubmitButtonState'](false)
          return
        }

        // 6、下单前校验弱网
        if (!this.canPayByWeakNetwork) {
          this['detail/setSubmitButtonState'](false)
          return
        }
        window.console.log('10) 再次校验弱网，直接跳转三方下单成功')

        // 7、跳转支付
        const respars = this.obtainParameterFusion()
        this.goPlaceOrder(respars)
      },

      obtainParameterFusion() {
        const orderpars = this.createOrderParams()
        let parameter = {}

        if (this.isAllExternalGames) {
          orderpars.skuId = ''
          const cpProductInfo = this.selectOuterSkuItem
          parameter = {
            cpProductInfo,
            ...orderpars,
          }
          return parameter
        }

        if (this.isParallelRequestsGame) {
          orderpars.skuId = ''
          orderpars.roleId = this.userRoles.roleId || ''
          const cpProductInfo = this.selectOuterSkuItem
          parameter = {
            cpProductInfo,
            ...orderpars,
          }
          return parameter
        }

        if (this.isStateOfSurvival) {
          orderpars.skuId = ''
          orderpars.skuName = ''
          let cpProductInfo = this.selectOuterSkuItem

          let _cpProductInfo = JSON.parse(cpProductInfo)
          delete _cpProductInfo.items
          _cpProductInfo = JSON.stringify(_cpProductInfo)

          parameter = {
            cpProductInfo: _cpProductInfo,
            ...orderpars,
          }
          return parameter
        }

        return orderpars
      },

      genshinPay() {
        this.isGenshinPay = true
        this.submitOrderRequest()
      },
      async submitOrderRequest() {
        const now = Date.now()
        if (now - this.lastSubmitClickTime < SUBMIT_CLICK_INTERVAL) return
        this.lastSubmitClickTime = now

        this['detail/setSubmitButtonState'](true)

        // warn 俄罗斯 原神 未登录 弹层支付
        if (!this.isGenshinPay) {
          const isGenPay = this.isHackGenshinPay()
          window.console.log('1) 判断是否为「原神」未登录的状态')
          if (!isGenPay) {
            this['detail/setSubmitButtonState'](false)
            return
          }
        }

        // warn 弱网限制
        const res = this.weakNetwork()
        window.console.log('2) 判断弱网限制')
        if (!res) {
          this['detail/setSubmitButtonState'](false)
          return
        }

        // warn: 校验code
        const isCodeType = this.checkCodeType()
        window.console.log('3) 判断是否为CODE模式类型')
        if (!isCodeType) {
          this['detail/setSubmitButtonState'](false)
          return
        }
        // warn 特殊CP需要登录
        const isExternalLogin = this.checkHackExternalCP()
        window.console.log('4) 判断是否为外部CP是否需要登录')
        if (!isExternalLogin) {
          this['detail/setSubmitButtonState'](false)
          return
        }
        this.handleSubmitStatus()

        this.trackGaPageOrder()
      },
      // true 1.不需要输入邮箱；2.输入的邮箱合法
      isEmailModelValid() {
        return (
          !isEmpty(this.notificationEmail) &&
          emailReg.test(this.notificationEmail)
        )
      },
      handleSubmitStatus() {
        if (this.uidModuleType === 6 && !this.isEmailModelValid()) {
          // Email模式 输入的邮箱不能是空的，不再往下执行
          this['detail/setUidValidator']({
            customTips: 'publicDetails.detail_email_error_tip',
            isInInput: false,
            isError: true,
            isSuccess: false,
            isLoading: false,
            showIcon: false,
          })
          return
        }
        const orderpars = this.createOrderParams()
        const start = Date.now()

        // 更新 应急弹层的状态
        this['detail/setSubmitCloudControl']({
          skuId: orderpars.skuId,
          payMethod: orderpars.payMethod,
          random: start, //页面未刷新、让watch每次都更新
        })
        window.console.log('5) 判断是否配置应急弹层')
      },

      // hack 兼容原神未登录的弹层支付
      isHackGenshinPay() {
        if (this.isGenshin && !this.isKwalletSelected && !this.isDesktop) {
          this.isGenshinLayer = true
          return false
        }
        return true
      },

      // hack 弱网的状态切换vuex的数据不更新
      weakNetwork() {
        const { skuId: newSkuid, skuPrice } = this.selectSkuItem
        const { skuId: oldSkuid, channelPrice } = this.selectChannelItem

        // 外部的SKU、通过价格进行关联
        if (
          this.isParallelRequestsGame ||
          this.isAllExternalGames ||
          this.isStateOfSurvival
        ) {
          return isEqual(skuPrice, channelPrice)
        }
        return newSkuid === oldSkuid
      },

      // 校验CODE类型、必须登录
      // 外部的SKU也会走自动登录下单流程
      checkCodeType() {
        if (
          (SHIPMEN_TTYPE.includes(this.awardType) && !this.isLogin) ||
          (this.isAllExternalGames && !this.isLogin)
        ) {
          this.gotoOrder = this.isKwalletSelected
          this.otherchannels = true
          this.curautopayname = this.selectChannelItem.payMethodName
          this.callLogin()
          return this.isLogin
        }
        return true
      },

      // 校验外部SKU必须要登录
      checkHackExternalCP() {
        if (this.isNotCheckGames && !this.isLogin) {
          this.callLogin()
          return this.isLogin
        }
        return true
      },

      // 调起登录弹层
      callLogin() {
        const start = Date.now()
        this['detail/setIsPierceLogoLayer'](start)
      },

      trackGaPageOrder() {
        let payMethodName = this.selectChannelItem.payMethodName || ''
        let trackCouponId = ''

        if (this.couponData && this.couponData.length) {
          let fCouponList = this.couponData.filter((item) => item.selected)

          if (fCouponList && fCouponList.length) {
            trackCouponId = fCouponList.map((item) => item.id).join('_')
          }
        }

        pageOrder({
          coupon: trackCouponId,
          page: this.gameName,
          payment_name: payMethodName,
        })
      },

      // 校验信用卡
      validateCreditCard() {
        const payMethod = this.selectChannelItem.payMethod
        const res = checkCreditCard(payMethod)
        if (res && !this.isLogin) {
          this.callLogin()
          return false
        }
        return true
      },
      // 检查是否能支付
      // 下单时的埋点
      // 优惠券下单：pubgm、原神、lords mobile、IK
      // 点击下单按钮时，判断实际支付的价格是否小于等于0，如果小于等于0，则触发弹窗提醒
      checkCanPay() {
        if (this.isIAP) return true
        let status = true
        const orderpars = this.createOrderParams()
        const trackCouponId = this.getCouponIds('_')
        if (
          this.hasCouponGames &&
          this.hasCouponGames.indexOf(this.FgameName) > -1
        ) {
          if (orderpars.payPrice <= 0) {
            // 提示 输入信息有误，请重试
            Toast.fail(this.$t('coupon.payerror'))
            // 打点
            pageOrderFail({
              error_code: 0,
              coupon: trackCouponId,
              sku_id: this.selectChannelItem.skuId,
            })
            status = false
          }
        }
        return status
      },
      // App内登录回来不刷新页面\
      // warn 同时之后扩展的时候、需要需要登录的游戏记得添加此方法
      updateAppReloadPage() {
        if (this.isApp) {
          this['detail/setAPPnoReloadPage'](true)
        }
      },
      // 校验wallet 逻辑
      checkWallet() {
        // 不是钱包的支付方式 直接放行
        if (!this.isKwalletSelected) return true
        if (this.isLogin && this.$refs.walletRef) {
          return this.$refs.walletRef.checkWalletReadyToPay()
        }
        this.updateAppReloadPage()
        // warn 相当于详情页的 this.$refs.h5Page.login('order')
        // ! 调起登录
        this.gotoOrder = true
        this.callLogin()
        return false
      },

      // 校验UID
      async checkUID() {
        // 隐藏了UID的模板 就不用校验了哈
        // 栗子：pubgm
        if (this.uidModuleType === 5) return true

        // 在CODE模式 || API-CODE模式 没有UID模板
        if ([1, 3].includes(this.uidModuleType)) return true

        if (this.uidModuleType === 6) {
          // Email模式 输入的邮箱不能是空的
          return this.isEmailModelValid()
        }

        if (this.isAllExternalGames || this.isParallelRequestsGame) {
          return true
        }

        try {
          const params = createUidParames({
            gameName: this.gameName,
            uid: this.cacheUserId,
            selectSkuItem: this.selectSkuItem,
            selectServerItem: this.selectServerItem,
          })
          const result = await injectionCheckUid(params)
          return result && result.res
        } catch (error) {
          window.console.warn('%c[_checkUID_]方法报错', 'color:#0f0', error)
          return false
        }
      },

      // 下单参数
      createOrderParams() {
        const sItem = this.selectServerItem
        const cpServerId = isEmpty(sItem) ? '' : sItem.cpServerId
        const { email, uid } = this.createAwardType()

        // 针对某些游戏、需要单独传递某些参数
        let hackpars = this.specialGameParas()

        const parameter = {
          country: this.region,
          game: this.gameName,
          source: this.source,
          payPrice: this.finalPrice, // 真正支付金额需要减去【折扣的金额】
          payMethod: this.selectChannelItem.payMethod || '',
          skuId: this.selectSkuItem.skuId,
          skuName: this.selectSkuItem.skuName,
          returnUrl: this.getReturnUrl(),
          isRoute: true,
          uid,
          email,
          password: this.encodedPw || '',
          couponIds: this.getCouponIds(),
          cpServerId,
          ...hackpars,
        }
        return parameter
      },

      // 特殊处理的游戏参数
      specialGameParas() {
        let params = {}

        if (this.isKungfuLegend) {
          params = {
            serverName: this.selectServerItem?.serverName,
            accountId: this.accountId,
            roleId: (() => {
              const { roleId: vuexRoleId } = this.userRoles
              if (vuexRoleId) {
                return vuexRoleId
              }
              return this.nickName && this.nickName.length
                ? this.nickName[0].roleId
                : ''
            })(),
          }
        } else if (this.isOnmyojiArena || this.isCpMd) {
          params = {
            roleId: this.serverId,
          }
        } else if (this.isInfinityKingdom) {
          params = {
            cpServerId: this.ikCpServerId,
          }
        } else if (this.isNotExternalInputServerGames) {
          params = {
            cpServerId: this.serverId,
          }
        }
        return params
      },
      // 根据发货类型、进行强校验 [详情CMS配置]
      // info: code模式：必须登录、必须传递email
      // info: API模式：必须传递UID
      createAwardType() {
        let email = '',
          uid = ''

        // code 模式
        if (SHIPMEN_TTYPE.includes(this.awardType)) {
          if (this.userInfo && this.userInfo.email) {
            email = this.userInfo.email
          } else {
            email = 'toplupeservice@aptostar.com'
          }
        }

        // API 模式
        if (this.awardType === 2) {
          if (this.isParallelRequestsGame) {
            uid = this.serverUserId?.value
          } else {
            uid = this.cacheUserId
          }
        }

        // 更新邮箱信息
        if (this.uidModuleType === 6 && this.isEmailModelValid()) {
          email = this.notificationEmail
        }

        return { email, uid }
      },

      // 获取选中的优惠券ID list
      // sep: 根据参数切割
      getCouponIds(sep = ',') {
        if (!this.couponData.length) return ''

        let flist = this.couponData.filter((item) => item.selected) || []
        if (!flist.length) return ''

        return flist.map((item) => item.userCouponId).join(sep)
      },

      // 下单接口
      async goPlaceOrder(params) {
        try {
          const result = await placeOrder(params)
          this.isGenshinLayer = false
          this.setBeginCheckout()
          this.setTTBeginCheckout()
          this.createdOrderFinish()
          this.setWalletPaidResult()
          this.jumpToCashier(result)
          this['detail/setAPPnoReloadPage'](false)
          this['detail/setSubmitButtonState'](false)
        } catch (error) {
          // 若日后使用该模板组件的游戏 CP 也要适配 msa 应用内弹窗，需要另做判断以便唤起账户风控提示弹窗 WarningPopup（置于 UserCenter 内）
          const { code } = error

          // todo ： 服务器接口优化，针对seagm类型的CP
          if (['2800'].includes(String(code))) {
            location && location.reload()
          }

          if (['1207', '1208'].includes(String(code))) {
            bus.$emit('show-account-risk', { errCode: code })
          }
          if (this.isKwalletSelected) {
            this.$refs.walletRef && this.$refs.walletRef.orderCatch(error)
          }
          window.console.warn('%c[_goPlaceOrder_]方法报错', 'color:#0f0', error)
          this['detail/setSubmitButtonState'](false)
        }
      },
      setBeginCheckout() {
        let { currency, skuId, skuName, originalPrice } = this.selectSkuItem
        let regionCode = regionCodeMap[this.region] || ''

        // 单独为pns、3D做hack
        if (this.isParallelRequestsGame) {
          currency = this.selectExternalSku.currency
          skuId = this.selectExternalSku.skuId
          skuName = this.selectExternalSku.skuName
        }

        const parames = {
          coupon: this.getCouponIds('_'),
          currency,
          value: this.finalPrice,
          page: this.gameName,
          items: [
            {
              // id	int	商品唯一标识	1+三位数字国家代码+sku_id，如巴西1001套餐记为10761001
              id: `${regionCode}${skuId}`,
              name: skuName,
              brand: `${this.gameName}_${this.region}`,
              price: originalPrice,
              quantity: 1,
            },
          ],
        }

        beginCheckout(parames)
      },
      setTTBeginCheckout() {
        const parames = {
          couponPayPrice: this.finalPrice,
          gameName: this.gameName,
          region: this.region,
          currency: this.selectSkuItem.currency,
          skuId: this.selectSkuItem.skuId,
        }
        beginCheckoutTT(parames)
      },
      createdOrderFinish() {
        storage.set('autoCreateOrder', 0)
      },
      setWalletPaidResult() {
        if (!this.isKwalletSelected) return

        trackWalletPaidResult({
          page: this.gameName,
          code: 1, // 下单成功
        })
      },

      // 跳转公共方法
      jpLocationHref(url) {
        if (this.isApp) {
          changeTitleBarMode(0)
        }
        jumpToPage(url)
      },

      // 跳转钱包的方法聚合
      jpWallet({ orderNo, url }) {
        tryToNative({
          url: `${url}&orderNo=${orderNo}`,
          params: JSON.stringify({ finishWhenBack: true }),
        }).catch(() => this.jpLocationHref(url + '&orderNo=' + orderNo))
      },

      // 跳转bar的方法聚合
      jpBrRegion({ orderNo, url }) {
        const returnUrl = encodeURIComponent(
          `${this.getReturnUrl()}&orderNo=${orderNo}`
        )
        const jumpUrl1 = `${url}&return_url=${returnUrl}`
        const jumpUrl2 = `${url}?return_url=${returnUrl}`
        tryToNative({
          url: url.indexOf('?') > -1 ? jumpUrl1 : jumpUrl2,
          params: JSON.stringify({ finishWhenBack: true }),
        }).catch(() =>
          this.jpLocationHref(url.indexOf('?') > -1 ? jumpUrl1 : jumpUrl2)
        )
      },

      // 统一处理 跳转支付通道外链
      jumpToCashier(data) {
        const { url, orderNo } = data || {}
        if (!this.getReturnUrl()) return ''

        // app内，跳转收银台后重置页面
        if (this.isApp) {
          this.$refs.walletRef && this.$refs.walletRef.appResetWallet()
        }

        if (this.isKwalletSelected) {
          this.jpWallet({ orderNo, url })
          return
        }

        if (this.region === 'br') {
          this.jpBrRegion({ orderNo, url })
          return
        }

        tryToNative({
          url,
          params: JSON.stringify({ finishWhenBack: true }),
        }).catch(() => this.jpLocationHref(url))
      },
    },
  }
</script>
<style lang="scss" scoped src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    .mains-desktop {
      display: none;
    }
  }
  @media (max-height: 600px) {
    .mains-btn-content {
      padding-bottom: 20px;
    }
  }
</style>
